import React from 'react'
import Style from './Award.css'

const Award = (props) => {
  return (
    <div style={Style} className="award-container">
      <table>
        {props.semiHeader && (
          <thead>
            <tr>
              {props.border && <th className="whiteBorderLeft">{props.semiHeader}</th>}
              {!props.border && <th>{props.semiHeader}</th>}
              {props.finalHeader && <th>{props.finalHeader}</th>}
            </tr>
          </thead>
        )}
        <tbody>
          <tr>
            <td>
              <div className="pad10b label">{props.semiLabel} </div>
              <div>
                {<span className="amount bold800">{props.semiAmount}</span>}
                {props.beginLabel && (
                  <p>
                    {props.beginLabel}
                    <br />
                    <br />
                  </p>
                )}
                {props.beginAmount && (
                  <>
                    <span className="amount bold800">{props.beginAmount}</span>
                  </>
                )}

                {props.perYear && <span className="perYear">{` ${props.perYear}`}</span>}
              </div>
            </td>
            {props.finalLabel && (
              <td>
                <div className="pad10b label">{props.finalLabel} </div>
                <div className="pad10tb">
                  {<span className="amount bold800">{props.finalAmount}</span>}
                  {<span className="perYear">{` ${props.perYear}`}</span>}
                </div>
              </td>
            )}
          </tr>
          <tr className="last-row">
            {props.fourYearAmount && (
              <td>
                {
                  <p>
                    {props.fourYearBonus}
                    <br />
                    <br />
                  </p>
                }

                {props.fourYearAmount && (
                  <span className="fourAmount bold800">{props.fourYearAmount}</span>
                )}
                {<span className="fourYear">{` ${props.fourYear}`}</span>}
              </td>
            )}

            {props.bonusAward && !props.additionalSemi && (
              <td>
                <div className="bonus pad10b">
                  {props.bonusAward}
                  <br />
                </div>
                {props.bonusAmount && (
                  <span className="fourAmount bold800 ">{props.bonusAmount}</span>
                )}
                {<span className="fourYear">{` ${props.perYear}`}</span>}
              </td>
            )}

            {props.additionalSemi && (
              <td>
                <div className="bonus">
                  {props.bonusAward}
                  <br />
                </div>
                <div className="bonusContainer">
                  <div>
                    {<div className="fourAmount bold800 pad10tb">{props.additionalSemi}</div>}
                    {props.additionalSemiLabel && (
                      <div className="additionalLabel">{props.additionalSemiLabel}</div>
                    )}
                    {/* <div className="additionalLabel prefix"> */}
                    {/* {props.prefix} */}
                    {/* <span className="italic">{` ${props.semiTitle}`}</span> */}
                    {/* </div> */}
                  </div>
                  {/* <div class="wrapper">
                    <div class="line"></div>
                    <div class="wordwrapper">
                      <div class="word">or</div>
                    </div>
                  </div> */}
                  <div>
                    <div className="additionalLabel pad10b">{props.additionalFinalLabel}</div>

                    <div className="fourAmount bold800">{props.additionalFinal}</div>
                    {/* <div className="additionalLabel prefix">
                      {props.prefix}
                      <span className="italic">{` ${props.finalTitle}`}</span>
                    </div> */}
                  </div>
                </div>
              </td>
            )}

            {props.finalFourAmount && (
              <td>
                {props.fourYearAmount && (
                  <span className="fourAmount">{props.finalFourAmount}</span>
                )}
                {<span className="fourYear">{` ${props.fourYear}`}</span>}
              </td>
            )}
          </tr>
        </tbody>
      </table>
    </div>
  )
}

export default Award
